/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_S3_Li3Inputs */

const en_guide_json_rest_api_s3_li3 = /** @type {(inputs: Guide_Json_Rest_Api_S3_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>Error response</strong>: <code>&#123;"error": &#123;"code": 404, "message": "Not found"&#125;&#125;</code>`)
};

const ko_guide_json_rest_api_s3_li3 = /** @type {(inputs: Guide_Json_Rest_Api_S3_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>에러 응답</strong>: <code>&#123;"error": &#123;"code": 404, "message": "Not found"&#125;&#125;</code>`)
};

const ja_guide_json_rest_api_s3_li3 = /** @type {(inputs: Guide_Json_Rest_Api_S3_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>エラーレスポンス</strong>: <code>&#123;"error": &#123;"code": 404, "message": "Not found"&#125;&#125;</code>`)
};

/**
* | output |
* | --- |
* | "<strong>Error response</strong>: <code>&#123;\"error\": &#123;\"code\": 404, \"message\": \"Not found\"&#125;&#125;</code>" |
*
* @param {Guide_Json_Rest_Api_S3_Li3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_s3_li3 = /** @type {((inputs?: Guide_Json_Rest_Api_S3_Li3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_S3_Li3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_s3_li3(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_s3_li3(inputs)
	return ja_guide_json_rest_api_s3_li3(inputs)
});